export default "__VITE_ASSET__2b5a6b72__"